// extracted by mini-css-extract-plugin
export var bankMethodIcon = "BankMethodIcon-module--bankMethodIcon--ded6d";